import { testIds } from '../../../test-ids';
import { SpinnerCircle, SpinnerOverlay } from './spinner.styles';

interface SpinnerProps {
  isFullScreen?: boolean;
  isSmall?: boolean;
}

const Spinner = ({ isFullScreen, isSmall }: SpinnerProps) => (
  <SpinnerOverlay
    $isFullScreen={isFullScreen}
    $isSmall={isSmall}>
    <SpinnerCircle data-testid={testIds.common.spinner} />
  </SpinnerOverlay>
);

export default Spinner;
